<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <article class="wrapper wrapper-content main-column full-column" v-if="searchOpen">
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_report_on_2.png" alt="">
            {{$t('OKR代理入力')}}
          </h1>
          <span class="info-right">
          </span>
        </div>
        <div v-if="isLiteMode">
          <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
        </div>
        <div v-else>
          <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
              <img src="static/img/assets/nav_people_on.png" alt="">
              {{$t('searchUserStr')}}
            </h1>
          </div>
          <section class="animated fadeInRight">
            <div class="ibox">
              <div class="ibox-content">
                <div class="ibox-title search-box">
                  <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent>
                        <div class="input-group">
                          <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="ibox-content search-resultview">
                  <ul v-if="searchText == ''">
                    <li><label>{{$t('checkUserStrType')}}</label></li>
                    <li v-if="this.getVisitedUsers.length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>

                    <template v-for="user in getVisitedUsers">
                      <li :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId" class="result-box">
                        <div class="cursor" @click="setUserKey(user.userId)">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                          <div class="search-userinfo">
                            <span class="search-username">{{ user.userInfo.userName }}</span>
                            <span class="search-userdept">{{ user.userInfo.dept }}</span>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                  <ul v-else>
                    <li><label>{{$t('searchResuleStrType')}}</label></li>
                    <li v-if="Object.keys(this.getUsersBySearchText).length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>
                    <template v-for="(user, key) in getUsersBySearchText">
                      <li :key="user.id" v-if="user && user.userInfo && key !== getUserId" class="result-box">
                        <div class="cursor" @click="setUserKey(key)">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                          <div class="search-userinfo">
                            <span class="search-username">{{ user.userInfo.userName }}</span>
                            <span class="search-userdept">{{ user.userInfo.dept }}</span>
                            <span class="search-userbio">{{ user.userInfo.userBio }}</span>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
      </article>
    <!-- MainView -->
      <article @click.self="closeAllDetailView" :class="{ 'full-column' : !open && !relationOpen }" class="wrapper wrapper-content main-column">
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_okr_on.png" alt="">
              {{$t('viewName.okr')}}
          </h1>
          <!-- ユーザー情報を上部空白部分に載せる -->
          <div class="wrapper">
            <span class="info-userimg">
              <img v-if="getUserInfoById(targetUser).userIcon" class="img-circle" :src="getUserInfoById(targetUser).userIcon"  :alt='getUserInfoById(targetUser).userName'>
              <img v-else class="img-circle" :src="'static/img/noImage.png'"  :alt='getUserInfoById(targetUser).userName'>
            </span>
            <span class="info-username">{{ getUserInfoById(targetUser).userName }}</span>
            <span>{{ getUserInfoById(targetUser).dept }}</span>
          </div>
          <!-- objective登録を追加 -->
          <router-link :to="{name: 'ObjectiveRegist', params: {proxyUserId: targetUser, isProxy: true }}">
            代理Objective登録
          </router-link>

          <span class="info-right">
            <select-drop-down v-on:set-selected-order="setSelectedOrder" :order="this.orderType"/>
          </span>
        </div>
        <section class="animated fadeInRight flex-option">
          <div v-for="(obj, index) in getCurrentIncompletedObjectives" :key="obj.id" v-if="obj.key && obj.objective.contentText" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index">
            <div @click="onClickObjective(obj.objective, obj.key, 'objectives')" class="ibox-title cursor">
              <objective :detailView="false" :content="obj.objective.contentText" :progress="obj.objective.progress ? '' + obj.objective.progress : '0'" :setReadOnly="'false'" :objective="true" />
              <div class="ibox-tools">
                <span @click.stop="setKeyresultOpen(obj.key)" class="info-menu cursor">
                  <button class="btn btn-secondary">
                    <i :class="{'chevronUp' : !getIsOpen(obj.key)}" class="fa fa-chevron-down"></i>
                    <span v-if="!getIsOpen(obj.key)">{{$t('indicateItemClose')}}</span>
                    <span v-else>{{$t('indicateAllNotice')}}</span>
                  </button>
                </span>
                <span class="info-right">
                  <span class="info-comment-detail" v-if="obj.objective.hasOwnProperty('sharedOwners') && Object.keys(obj.objective['sharedOwners']).length > 0">
                    <img :src="'static/img/assets/nav_people_on.png'">
                  </span>
                  <span class="info-comment-detail">
                    <span class="isExistUnread">
                      <img src="static/img/assets/comment.png">
                    </span>
                    <span v-bind:class="{ unread: isUnreadCommentsExist('objectives', obj.key, obj.objective.comments) }">{{getCommentsByCommentIdsTargetType(obj.objective.comments || {}, 'objectives').length}}</span>
                  </span>
                  <span class="info-comment-detail">
                    <img src="static/img/assets/relation_object_list.png">
                    <span v-bind:class="{ unread: isUnreadOKRRelationExist(obj.objective, obj.key, 'objectives') }">{{ obj.objective.relations ? Object.keys(obj.objective.relations).length : 0 }}</span>
                  </span>
                  <div class="info-comment-right">
                    <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                    <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                  </div>
                  <okr-drop-down :tag="tag" :item="obj.objective" :id="obj.key" :isProxy="true" :uid="targetUser"/>
                </span>
              </div>
            </div>
            <div :class="{'keyResultClose' : getIsOpen(obj.key)}" class="ibox-content key-indent">
              <div @click="onClickObjective(keyresult, key, 'keyresults')" v-for="(keyresult, key) in getTargetKeyresults(obj.key)" :key="key" v-if="keyresult.contentText" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult)}">
                <div>
                  <span class="comp"></span>
                  <objective :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? '' + keyresult.progress : '0'" :setReadOnly="'false'" :objective="false" />
                </div>
                <div class="ibox-tools">
                  <span class="info-menu"></span>
                  <span class="info-right">
                    <span class="info-comment-detail" v-if="keyresult.hasOwnProperty('sharedOwners') && Object.keys(keyresult['sharedOwners']).length > 0">
                      <img :src="'static/img/assets/nav_people_on.png'">
                    </span>
                    <span class="info-comment-detail">
                      <span class="isExistUnread">
                        <img src="static/img/assets/comment.png">
                      </span>
                      <span v-bind:class="{ unread: isUnreadCommentsExist('keyresults', key, keyresult.comments) }">{{getCommentsByCommentIdsTargetType(keyresult.comments || {},'keyresults').length}}</span>
                    </span>
                    <span class="info-comment-detail">
                      <img src="static/img/assets/relation_object_list.png">
                      <span v-bind:class="{ unread: isUnreadOKRRelationExist(keyresult, key, 'keyresults') }">{{ keyresult.relations ? Object.keys(keyresult.relations).length : 0 }}</span>
                    </span>
                    <div class="info-comment-right">
                      <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{keyresult.startDate}}</span>
                      <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{keyresult.dueDate}}</span>
                    </div>
                    <okr-drop-down v-if="!getIsComp(keyresult)" :tag="'progressKey'" :item="keyresult" :id="key" :isProxy="true" :uid="targetUser"/>
                    <okr-drop-down v-else :tag="'compKey'" :item="keyresult" :id="key" :isProxy="true" :uid="targetUser"/>
                  </span>
                </div>
              </div>
              <div class="ibox-child cursor text-center add-key" style="padding-left:0;">
                <div id="add-key1" class="panel-footer info-add">
                  <router-link :to="{ name: 'KeyresultRegist', params: { parentObjId: obj.key, proxyUserId: targetUser, isProxy: true } }" class="btn btn-success"><i class="fa fa-plus"></i>{{$t('addKeyResultStr')}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
      <okr-detail-view :targetItemKey="targetItemKey" :targetType="targetType" :targetUserId="targetUser" ref="okrDetailView" @close-detail-view="onClickCloseDetailView" @open-add-relation="onClickAddRelation"/>
      <okr-add-relation-detail-view :targetItemKey="targetItemKey" :targetType="targetType" ref="okrAddRelationDetailView" @close-detail-view="onClickCloseAddRelationDetailView" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { liteMode } from '@/main.js'
import OkrDropDown from '@/components/Okr/OkrDropDown'
import Objective from '@/components/Okr/Objective'
import SelectDropDown from '@/components/Okr/SelectDropDown'
import OkrDetailView from '@/components/DetailView/OkrDetailView'
import OkrAddRelationDetailView from '@/components/DetailView/OkrAddRelationDetailView'

export default {
  name: 'ProxyOkr',
  components: {
    SelectDropDown,
    Objective,
    OkrDropDown,
    OkrDetailView,
    OkrAddRelationDetailView
  },
  data: function () {
    return {
      searchOpen: true,
      isLiteMode: liteMode,
      tag: 'progress',
      open: true,
      searchText: '',
      keyresultOpen: {},
      targetItemKey: '',
      targetType: 'objectives',
      relationOpen: false,
      baseUser: '',
      isShowCommentForm: true
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById'
    ]),
    ...mapGetters('okrs/', [
      'getIsReadRelation'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByParentObjId'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByUserId'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    ...mapGetters('comments/', [
      'getIsReadComment',
      'getCommentsByCommentIdsTargetType'
    ]),
    targetUser: {
      get () {
        return this.baseUser
      },
      set (v) {
        this.baseUser = v
      }
    },
    isMatchPath () {
      return this.$route.name === 'ProxyOkr'
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        // return this.getUsers
        return {}
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getCurrentIncompletedObjectives: function () {
      if (this.targetUser) {
        if (this.getObjectivesByUserId(this.targetUser)) {
          let incompletedObjectives = []
          const currentObjectives = this.getObjectivesByUserId(this.targetUser)
          for (let key in currentObjectives) {
            if (key === '.key') { continue }
            if (currentObjectives[key] && currentObjectives[key].contentText !== '') {
              if (!currentObjectives[key].isComplete) {
                incompletedObjectives.push({key: key, objective: currentObjectives[key]})
              } else if (currentObjectives[key].isComplete === false) {
                incompletedObjectives.push({key: key, objective: currentObjectives[key]})
              } else {
                continue
              }
            }
          }
          if (this.orderType.key === '') {
            return incompletedObjectives.slice(0, this.objectiveCount)
          } else {
            const orderType = this.orderType
            incompletedObjectives.sort(function (a, b) {
              // console.log('orderType.key:::', orderType.targetKey)
              if (!a.objective[orderType.targetKey] && !b.objective[orderType.targetKey]) {
                return 0
              } else if (!a.objective[orderType.targetKey]) {
                return -1
              } else if (!b.objective[orderType.targetKey]) {
                return 1
              } else {
                return a.objective[orderType.targetKey] - b.objective[orderType.targetKey]
              }
            })
            if (orderType.isDesc) {
              return incompletedObjectives.reverse().slice(0, this.objectiveCount)
            } else {
              return incompletedObjectives.slice(0, this.objectiveCount)
            }
          }
        } else {
          return []
        }
      } else {
        return []
      }
    },
    orderType () {
      let ret
      switch ((this.getCurrentUserInfo || {}).okrOrder) {
        case 'updated_desc':
          ret = {
            targetKey: 'modifiedAt',
            isDesc: true
          }
          break
        case 'updated_asc':
          ret = {
            targetKey: 'modifiedAt',
            isDesc: false
          }
          break
        case 'created_asc':
          ret = {
            targetKey: 'createdAt',
            isDesc: false
          }
          break
        case 'created_desc':
        default:
          ret = {
            targetKey: 'createdAt',
            isDesc: true
          }
          break
      }
      return ret
    }
  },
  mounted () {
    if (this.$route.params.targetUser) {
      this.targetUser = this.$route.params.targetUser
      this.open = true
      this.searchOpen = false
    }
  },
  methods: {
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    ...mapActions('okrs/', {
      setProgress: 'SET_ITEM_PROGRESS',
      addRelation: 'ADD_RELATION'
    }),
    ...mapActions('users/', {
      setOkrOrderType: 'SET_OKR_ORDER_TYPE'
    }),
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    setUserKey (userKey) {
      this.targetUser = userKey
      this.open = true
      this.searchOpen = false
      if (this.getUserId !== userKey) { this.setVisit(userKey) }
    },
    getTargetKeyresults (key) {
      return this.getKeyresultsByParentObjId(key)
    },
    setSelectedOrder: function (value) {
      if (value.targetKey === 'createdAt') {
        if (value.isDesc) {
          this.setOkrOrderType('created_desc')
        } else {
          this.setOkrOrderType('created_asc')
        }
      } else
      if (value.targetKey === 'modifiedAt') {
        if (value.isDesc) {
          this.setOkrOrderType('updated_desc')
        } else {
          this.setOkrOrderType('updated_asc')
        }
      }
      this.objectiveCount = 30
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.objectiveCount - 1) {
        this.objectiveCount += 30
      }
    },
    onClickObjective: function (obj, key, type) {
      console.log(type, obj)
      if (this.relationOpen) this.relationOpen = false
      this.targetItemKey = key
      this.targetType = type
      if (!this.open) {
        this.open = true
      }
      if (this.$refs.okrDetailView) {
        this.$refs.okrDetailView.openDetailView()
        this.$refs.okrAddRelationDetailView.relationOpen = false
      }
      // this.$ref.checkTransition()
      if (!this.isShowCommentForm) {
        for (let relationKey in obj.relations) {
          if (!this.getIsReadRelation(type, this.getUserId, key, relationKey)) {
            this.setReadTime({
              itemType: 'relations',
              targetType: type,
              targetOwner: this.getUserId,
              targetId: key,
              relationKey: relationKey,
              readTime: new Date().getTime()
            })
          }
        }
      } else {
        for (let commentId in obj.comments) {
          if (!this.getIsReadComment(type, this.getUserId, key, commentId)) {
            this.setReadTime({
              itemType: 'comments',
              targetType: type,
              targetOwner: this.getUserId,
              targetId: key,
              itemId: commentId,
              readTime: new Date().getTime()
            })
          }
        }
      }
    },
    setKeyresultOpen: function (objectiveId) {
      Vue.set(this.keyresultOpen, objectiveId, Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.keyresultOpen[objectiveId])
    },
    getIsOpen: function (objectiveId) {
      return Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId]
    },
    isUnreadCommentsExist (itemType, itemId, commentIds) {
      for (let commentId in commentIds) {
        if (!this.getIsReadComment(itemType, this.getUserId, itemId, commentId)) {
          return true
        }
      }
      return false
    },
    isUnreadOKRRelationExist (obj, key, itemType) {
      for (let relationKey in obj.relations) {
        if (!this.getIsReadRelation(itemType, this.getUserId, key, relationKey)) {
          return true
        }
      }
      return false
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete
    },
    onClickCloseDetailView () {
      this.open = false
    },
    onClickAddRelation: function () {
      this.open = false
      this.$refs.okrDetailView.closeDetailView()
      this.$nextTick(() => {
        this.relationOpen = true
        this.$refs.okrAddRelationDetailView.openDetailView()
      })
      console.log('AddRelation open !')
    },
    closeAllDetailView () {
      this.$refs.okrDetailView.closeDetailView()
      this.$refs.okrAddRelationDetailView.closeDetailView()
      this.open = false
      this.relationOpen = false
    },
    onClickCloseAddRelationDetailView () {
      this.relationOpen = false
      this.open = true
      this.$refs.okrDetailView.openDetailView()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/okr/ProxyOkr.vue